import { AccessProfile } from '@api-model/account';
import { apiPaths } from '@infrastructure/http/apiPaths';
import { useApi } from '@infrastructure/http/useApi';
import { unwrapResult } from '@reduxjs/toolkit';
import { alarmSubscriptionsReducer } from '@root/store/alarmSubscriptions/AlarmSubscriptionsReducer';
import { accountsReducer } from '@root/store/library-stores/accounts';
import { useAppDispatch, useAppSelector } from '@root/store/store';
import { useNotifications } from '@shared/hooks/useNotifications';
import { useCallback } from 'react';

export const useUserDetailsDataSource = () => {
  const dispatch = useAppDispatch();
  const { handleSuccess } = useNotifications();

  const { alarmSubscriptions } = useAppSelector((state) => state.alarmSubscriptions);

  const isAlarmSubscribedForAccount = Boolean(alarmSubscriptions?.isSubscribedForAccount);

  const [getUserAccessProfile, userAccessProfile, loading, error] = useApi<AccessProfile>('', 'get');

  const handleGetUserAccessProfile = useCallback(
    (userId: number) => {
      if (!userId) return;

      const url = apiPaths.users.accessProfile({ id: userId });
      getUserAccessProfile({ additionalOptions: { url } }).catch(() =>
        dispatch(accountsReducer.slice.actions.setUserRole(null))
      );
    },
    [dispatch, getUserAccessProfile]
  );

  //

  const handleSubscriptionForAccount = useCallback(() => {
    dispatch(
      alarmSubscriptionsReducer.thunks.handleSubscribeAlarmsForAccount({ subscribe: !isAlarmSubscribedForAccount })
    )
      .then(unwrapResult)
      .then(() => {
        handleSuccess(
          `Successfully ${isAlarmSubscribedForAccount ? 'unsubscribed from' : 'subscribed to'} all sites notification`,
          'Sites Notification'
        );
      });
  }, [isAlarmSubscribedForAccount, dispatch, handleSuccess]);

  return {
    userAccessProfile,
    getUserAccessProfile: handleGetUserAccessProfile,
    loading,
    error,
    //
    handleSubscriptionForAccount,
    isAlarmSubscribedForAccount,
  };
};
